// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux
import scenarioParser from './scenarioParser';
import { getPlantingPlanParams } from 'planting-plan-form/selectors';
import { getProductValidationValues } from 'user/selectors';

// Action Types
export const typePrefix = 'vra/scenarios/';
export const actions = [
  'CLEAR_SCENARIOS',
  'STORE_SCENARIO',
  'SET_ACTIVE_SCENARIO_UUID',
  'SET_ORIGINAL_SCENARIO_UUID',
  'SET_YOUR_PLAN_SCENARIO_UUID'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer
export default function reducer(
  state = {
    allScenarios: []
  },
  action = {}
) {
  switch (action.type) {
    case actions.CLEAR_SCENARIOS:
      return {
        ...state,
        activeScenarioUuid: undefined,
        allScenarios: [],
        originalScenarioUuid: undefined,
        yourPlanScenarioUuid: undefined
      };

    case actions.STORE_SCENARIO:
      return {
        ...state,
        activeScenarioUuid: action.payload.scenario.scenarioUuid,
        allScenarios: [action.payload.scenario, ...state.allScenarios]
      };

    case actions.SET_ACTIVE_SCENARIO_UUID:
      return {
        ...state,
        activeScenarioUuid: action.payload
      };

    case actions.SET_ORIGINAL_SCENARIO_UUID:
      return {
        ...state,
        originalScenarioUuid: action.payload.scenarioUuid || state.originalScenarioUuid
      };
    
    case actions.SET_YOUR_PLAN_SCENARIO_UUID:
      return {
        ...state,
        yourPlanScenarioUuid: action.payload.scenarioUuid
      };

    default:
      return state;
  }
}

// Action Creators

export const clearScenarios = () => {
  return {
    type: actions.CLEAR_SCENARIOS
  };
};

export const setActiveScenarioUuid = (scenarioUuid) => {
  return {
    type: actions.SET_ACTIVE_SCENARIO_UUID,
    payload: scenarioUuid
  };
};

export const setOriginalScenarioUuid = (scenarioUuid) => {
  return {
    type: actions.SET_ORIGINAL_SCENARIO_UUID,
    payload: { scenarioUuid }
  };
};

export const setYourPlanScenarioUuid = (scenarioUuid) => {
  return {
    type: actions.SET_YOUR_PLAN_SCENARIO_UUID,
    payload: { scenarioUuid }
  };
};

/**
 * 
 * @param {Script} script
 * @returns {AnyAction}
 */
export const parseAndStoreScenario = (script) => {
  return (dispatch, getState) => {
    const state = getState();
    const plantingPlanParams = Object.assign({}, getPlantingPlanParams(state)); // create new copy
    const productValidationValues = getProductValidationValues(state);
    const scenario = scenarioParser({ state, script, plantingPlanParams, productValidationValues });

    dispatch({
      type: actions.STORE_SCENARIO,
      payload: { scenario }
    });
  };
};
